import { createContext, SetStateAction, Dispatch } from 'react';

type TContext = {
	activeTab: number;
	onChange?: (tabIndex: number) => void;
	setActiveTab: Dispatch<SetStateAction<number>>;
}

export const TabBarContext = createContext<TContext | null>(null);
